export default "__VITE_ASSET__ef7bc4b4__"